<template>
  <el-card
    class="product-card"
    v-bind:class="{ hoverShadow: shadowOnHover }"
    :body-style="{ padding: '0px', width: '100%' }"
  >
    <!-- FAVORITES TOGGLE -->
    <div class="favorite-wrapper">
      <favorite-icon
        :is-favorited="
          currentUser.favoriteProducts.includes(Number(product.id))
        "
        :interactive-favorite="interactiveFavorite"
        @toggle="handleToggleFavorite(product.id)"
      ></favorite-icon>
    </div>

    <!-- MAIN CARD CONTENT -->
    <router-link
      class="product-content"
      :to="productDetailRoute"
    >
      <div
        class="product-image"
        :style="{
          backgroundImage: productImage ? `url(${productImage})` : undefined,
        }"
      >
        <div class="new" v-if="product.flagAsNew">
          {{ $t('productNewFlag') }}
        </div>
      </div>
      <div class="product-copy">
        <!-- Product details -->
        <div>
          <p class="category-title">
            {{ categoryTitle ? categoryTitle : '&nbsp;' }}
          </p>
          <p class="product-title">
            {{ removeCategoryTitleAndNew(product.title, categoryTitle) }}
          </p>
        </div>

        <!-- "View Product" slide-up message -->
        <div class="view-product">
          <span class="view-products-text">
            {{ $t('productCardViewDetails') }}
          </span>
        </div>
      </div>
    </router-link>
  </el-card>
</template>

<script>
import FavoriteIcon from '../favorites/FavoriteIcon.vue';
import user from '../user';
import { mapActions } from 'vuex';
import { buildProductDetailRoute } from './product.util';

export default {
  name: 'ProductCardView',
  props: [
    'categoryTitle',
    'product',
    'currentUser',
    'interactiveFavorite',
    'favoritesPages',
    'shadowOnHover',
    'productsPage',
  ],
  components: { FavoriteIcon },
  computed: {
    productImage() {
      const img =
        this.product && this.product.mainImage
          ? this.product.mainImage[0]
          : null;

      return img && img.url ? img.url : null;
    },
    productDetailRoute() {
      return buildProductDetailRoute(this.product || {});
    },
  },
  methods: {
    open(id) {
      this.$confirm(this.$t('favoritesRemovalConfirmation'), {
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('applicationCancel'),
      })
        .then(() => {
          this.toggleFavorite(Number(id));
        })
        .catch(() => {
          return;
        });
    },
    removeCategoryTitleAndNew(productTitle, categoryTitle) {
      const pluralTitle = `${categoryTitle}s`;
      return productTitle
        .replace(pluralTitle, '')
        .replace(categoryTitle, '')
        .replace('New ', '');
    },
    ...mapActions(user.store.namespace, ['toggleFavorite']),
    handleToggleFavorite(id) {
      if (!this.interactiveFavorite) {
        return;
      } else if (!this.productsPage) {
        this.open(id);
      } else {
        this.toggleFavorite(Number(id));
      }
    },
  },
};

////////
</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

.product-card {
  height: 100%;
  align-self: stretch;
  position: relative;
  padding-top: 16px;
}

.product-content {
  &:hover {
    .view-product {
      top: calc(var(--image-height) + 25px);
      bottom: 0;
    }
  }
}

.hoverShadow {
  &:hover {
    box-shadow: 0px 8px 50px rgba(0, 0, 0, 0.3);
  }
}

// define --image-height in the component that calls this one
// to customize image height

.product-image {
  height: var(--image-height);
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0px 20px;
}

.product-copy {
  display: block;
  padding: 10px 20px 20px 20px;
}

.category-title {
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: bold;
  font-family: $font-family-headings;
  color: $--color-grayscale-4;
  margin-bottom: 5px;
  margin: 0px;
}

.product-title {
  font-size: 1.125rem;
  text-transform: uppercase;
  font-weight: bold;
  font-family: $font-family-headings;
  color: $--color-secondary;
  margin-top: 0px;
  margin-bottom: 0px;
}

.new {
  background-image: url(@/assets/images/new-rectangle.svg);
  color: $--color-white;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  padding: 5px 0px 5px 20px;
  text-transform: uppercase;
  font-size: 0.75rem;
  font-family: $font-family-headings;
  font-weight: bold;
}

.view-product {
  background-color: #e50b19; // $--color-primary was not overriding the element default
  color: $--color-white;
  position: absolute;
  top: 100%;
  bottom: calc(var(--image-height) - 100%);
  left: 0;
  right: 0;
  cursor: pointer;
  text-align: center;
  transition: all 200ms ease-in;
  text-transform: uppercase;
  font-family: $font-family-headings;
  font-weight: bold;
  font-size: 0.875rem;
  display: flex;
  align-items: center;

  @include res(md-and-down, $--breakpoints-spec) {
    display: none;
  }

  & > .view-products-text {
    display: block;
    margin-right: auto;
    margin-left: auto;
  }
}

.favorite-wrapper {
  position: absolute;
  right: 10px;
  top: 10px;
}

.button {
  width: 100%;
  display: none;
  margin-top: 5px;
  padding: 20px 35px;
  font-size: 14px;
  @include res(md-and-down, $--breakpoints-spec) {
    display: inline;
  }
}

.link-button-wrap {
  display: none;
  @include res(md-and-down, $--breakpoints-spec) {
    display: inline;
  }
}
</style>
